import apiClient from '../connections/api'

const executionReportsRoutes = {
    getExecutionByReportId: (reportId, config = {}) => {
        return apiClient.get(`/execution-reports/by-report/${reportId}`, config)
    },
    startExecutionReport: (reportId, config = {}) => {
        return apiClient.post('/execution-reports/start', { reportId }, config)
    },
    syncExecutionReports: (reportIds, config = {}) => {
        return apiClient.post('/execution-reports/sync', reportIds, config)
    },
    bulkPrepareExecutionReports: (reportIds, config = {}) => {
        return apiClient.post('/execution-reports/bulk-prepare', reportIds, config)
    },
    bulkAssignExecutionReports: (reportIds, config = {}) => {
        return apiClient.post('/execution-reports/bulk-assign', reportIds, config)
    },
    getExecutionReportById: (reportId, userId, setPercentDownload, config = {}) => {
        return apiClient.get(`/execution-reports/getExecutionReportById?reportId=${reportId}&userId=${userId}`,
            {
                timeout: 20000,
                ...config
            },
            {
                onDownloadProgress: progressEvent => {
                    const total = 50000
                    const current = progressEvent.loaded

                    const percentCompleted = Math.floor(current / total * 100)
                    if (setPercentDownload) {
                        setPercentDownload(percentCompleted)
                    }
                }
            })
    },
    createExecutionReport: (reportData, config = {}) => {
        const requestBody = {
            reportData
        }
        return apiClient.post('/execution-reports/createExecutionReport', requestBody, config)
    },
    createExecutionReportFromReportData: (report, config = {}) => {
        return apiClient.post('/execution-reports/createExecutionReportFromReportData', report, config)
    },
    saveExecutionReportByItem: (executionId, page, index, item, reportId, config = {}) => {
        return apiClient.patch('/execution-reports/item', {
            executionId, page, index, item, reportId
        }, config)
    },
    completeExecution: (executionId, config = {}) => {
        return apiClient.post(`/execution-reports/${executionId}/complete`, {}, config)
    },
    countNoChecks: (reportId, config = {}) => {
        return apiClient.get(`/execution-reports/count-no-checks/${reportId}`, config)
    }
}

export default executionReportsRoutes
